import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LanguageRegionMap } from 'src/app/types';
import { AuthService } from '../services/auth/auth.service';
import { TranslateService } from '../services/translation/translate.service';

@Injectable({
  providedIn: 'root',
})
export class AccountCompletionGuard {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private Auth: AuthService,
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {

    const lang = this.translate.language as LanguageRegionMap;
    await this.Auth.reloadAuthData();
    const UserProfile = this.Auth.userData;
    const authData = this.Auth.authData();

    if (!UserProfile) {
      this.router.navigateByUrl(`/${lang}/login?redirect=${state.url}`);
      return false;
    }
    if (authData?.hasAccess) {
      return true;
    }
    else if (UserProfile && !UserProfile?.isEmailVerified ) {
      this.router.navigateByUrl(`/verify-email-code?redirect=${state.url}`);
    } 
    else if (UserProfile && !UserProfile?.isPhoneVerified ) {
      this.router.navigateByUrl(`/verify-phone?redirect=${state.url}`);
    } 
    else if (authData?.userStatus !== 'ACCEPTED') {
      this.router.navigateByUrl(`/${lang}/validate?redirect=${state.url}`);
    }
    return true;
  }
}
